import MobileFirstHeader from '@/components/molecules/Header/variants/MobileFirstHeader';
import { Flex, VStack } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';
interface Props extends PropsWithChildren {
  headerHidden?: boolean;
}

const MobileFirstPageTemplate = ({ headerHidden, children }: Props) => {
  return (
    <Flex width={'100%'} direction={'column'} alignItems={'center'} minHeight={'100vh'}>
      {!headerHidden && <MobileFirstHeader />}
      <VStack width={'100%'} height={'100%'}>
        {children}
      </VStack>
    </Flex>
  );
};

export default MobileFirstPageTemplate;
